export default "__VITE_ASSET__BNvKiqpJ__"